/* eslint-disable */
import {
  Box,
  Fab,
  Grid,
  TextField,
  Tooltip,
  Typography,
  Paper,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import SearchIcon from "@mui/icons-material/Search";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { useEffect, useState, useRef } from "react";
import Message from "../../utils/Message.jsx";
import DatosAccesorio from "./DatosAccesorio.jsx";
import DatosArmazon from "./DatosArmazon.jsx";
import DatosAnteojoSol from "./DatosAnteojoSol.jsx";
import DatosBlock from "./DatosBlock.jsx";
import DatosCristal from "./DatosCristal.jsx";
import DatosFornitura from "./DatosFornitura.jsx";
import DatosLenteContacto from "./DatosLenteContacto.jsx";
import DatosMaterialLaboratorio from "./DatosMaterialLaboratorio.jsx";
import DatosServicio from "./DatosServicio.jsx";
import DatosSolucionLimpieza from "./DatosSolucionLimpieza.jsx";
import DatosTratamiento from "./DatosTratamiento.jsx"
import { getArticuloData, getArticuloStock } from "../../services/ArticuloService.js";
import { limpiaCodigo } from "../../../project/utils/utils";
import WaitingDialog from "../../utils/WaitingDialog";
//
// ###########################################################################
//
const ConsultaArticulo = () => {
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [codigoArticulo, setCodigoArticulo] = useState("");
  const [idArticulo, setIdArticulo] = useState("");
  const [obtenerStock, setObtenerStock] = useState(false);
  const [tipoArticulo, setTipoArticulo] = useState("");
  const [articuloData, setArticuloData] = useState({});
  const [articuloStockAreaRows, setArticuloStockAreaRows] = useState([]);
  const inputRef = useRef(null);

  const tableColumns = [
    {
      field: "descripcion_area",
      headerName: "Sucursal/Area",
      headerAlign: "center",
      align: "left",
      flex: 6,
      sortable: false,
      renderCell: (params) => {
        const value = params.row.descripcion_area?.toUpperCase() || "";
        const esSucursalActual = params.row.id_area === localStorage.getItem("id_area_ventas");
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",   // ✅ centra vertical
              height: "100%",         // ✅ ocupa toda la celda
              width: "100%",
            }}
          >
            <Typography
              variant="body2"
              sx={{
                fontWeight: esSucursalActual ? 600 : 400,
                color: esSucursalActual ? "primary.main" : "text.primary",
              }}
            >
              {value}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "cantidad_disponible",
      headerName: "Cantidad disponible",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        const value = params.row.cantidad_disponible;
        const esSucursalActual = params.row.id_area === localStorage.getItem("id_area_ventas");
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",     // ✅ centra vertical
              justifyContent: "center", // ✅ centra horizontal
              height: "100%",           // ✅ ocupa toda la celda
              width: "100%",
            }}
          >
            <Typography
              variant="body2"
              sx={{
                fontWeight: esSucursalActual ? 600 : 400,
                color: esSucursalActual ? "primary.main" : "text.primary",
              }}
            >
              {value}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "cantidad_por_recibir",
      headerName: "Cantidad por recibir",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        const value = params.row.cantidad_por_recibir;
        const esSucursalActual = params.row.id_area === localStorage.getItem("id_area_ventas");
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",   // ✅ centra vertical
              justifyContent: "center", // ✅ horizontal
              height: "100%",         // ✅ ocupa toda la celda
              width: "100%",
            }}
          >
            <Typography
              variant="body2"
              sx={{
                fontWeight: esSucursalActual ? 600 : 400,
                color: esSucursalActual ? "primary.main" : "text.primary",
              }}
            >
              {value}
            </Typography>
          </Box>
        );
      },
    },
  ];

  const tableOptions = {
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
    hideFooter: true,
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    if (obtenerStock === true && idArticulo.trim() !== "") {
      loadArticuloStock();
      setObtenerStock(false);
    }
  }, [obtenerStock]);
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setCodigoArticulo(e.target.value);
  };
  //
  // ################################################################################
  //
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      // opcional, evita submit de form
      e.preventDefault();
      loadArticulo();
    }
  };
  //
  // ################################################################################
  //
  const loadArticulo = () => {

    const _codigoArticulo = limpiaCodigo(codigoArticulo);

    if (_codigoArticulo === "") {
      return;
    }

    if (_codigoArticulo.length > 20) {
      setMessage({
        messageText: "El código de artículo no es válido",
        severity: "warning",
      });
      setShowMessage(true);
      return;
    }

    setCodigoArticulo(_codigoArticulo);

    loadArticuloData(_codigoArticulo);
  };
  //
  // ################################################################################
  //
  const loadArticuloData = async (parCodigoArticulo) => {

    let _params = {
      codigo: parCodigoArticulo,
    };

    setIsDoingSomething(true);
    const response = await getArticuloData(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      // recibo los datos del backend

      setArticuloData(response.data.data[0]);
      setTipoArticulo(response.data.data[0].tipo_articulo);
      setIdArticulo(response.data.data[0].id);
      setObtenerStock(true);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const cleanArticulo = () => {

    setCodigoArticulo("");
    setIdArticulo("");
    setTipoArticulo("");
    setArticuloData({});
    setArticuloStockAreaRows([]);

    inputRef.current?.focus();
  };
  //
  // ################################################################################
  //
  const loadArticuloStock = async () => {

    let _params = {
      id: idArticulo,
    };

    setIsDoingSomething(true);
    const response = await getArticuloStock(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      // recibo los datos del backend
      setArticuloStockAreaRows(response.data.data);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //

  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1} >
          <Box sx={{ p: 1 }}>
            <Grid container spacing={1}>

              <Grid item xs={12} sx={{ mt: 2, mb: 2 }}>
                <Typography variant="h5" display="block" gutterBottom>
                  Consulta de precios y stock de Artículos
                </Typography>
              </Grid>

              <Grid item xs={12} sm={12} md={2} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  id="codigoArticulo"
                  label="Código de Artículo"
                  size="small"
                  inputProps={{
                    autoComplete: "off",
                  }}
                  name="codigoArticulo"
                  value={codigoArticulo}
                  variant="outlined"
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                  inputRef={inputRef}
                  autoFocus
                />
              </Grid>

              <Grid item xs={6}>
                <Tooltip title="buscar">
                  <Fab
                    sx={{ ml: 1, mr: 1 }}
                    color="primary"
                    aria-label="add"
                    size="small"
                    onClick={loadArticulo}
                  >
                    <SearchIcon />
                  </Fab>
                </Tooltip>

                <Tooltip title="limpiar">
                  <Fab
                    sx={{ ml: 1, mr: 1 }}
                    color="outlined"
                    aria-label="add"
                    size="small"
                    onClick={cleanArticulo}
                  >
                    <CleaningServicesIcon />
                  </Fab>
                </Tooltip>
              </Grid>

              {tipoArticulo === "accesorio" && (
                <>
                  <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                    <DatosAccesorio articulo={articuloData} />
                  </Grid>
                </>
              )}

              {tipoArticulo === "armazon" && (
                <>
                  <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                    <DatosArmazon articulo={articuloData} />
                  </Grid>
                </>
              )}

              {tipoArticulo === "anteojo-sol" && (
                <>
                  <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                    <DatosAnteojoSol articulo={articuloData} />
                  </Grid>
                </>
              )}

              {tipoArticulo === "block" && (
                <>
                  <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                    <DatosBlock articulo={articuloData} />
                  </Grid>
                </>
              )}

              {tipoArticulo === "cristal" && (
                <>
                  <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                    <DatosCristal articulo={articuloData} />
                  </Grid>
                </>
              )}

              {tipoArticulo === "fornitura" && (
                <>
                  <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                    <DatosFornitura articulo={articuloData} />
                  </Grid>
                </>
              )}

              {tipoArticulo === "lente-contacto" && (
                <>
                  <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                    <DatosLenteContacto articulo={articuloData} />
                  </Grid>
                </>
              )}

              {tipoArticulo === "material-laboratorio" && (
                <>
                  <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                    <DatosMaterialLaboratorio articulo={articuloData} />
                  </Grid>
                </>
              )}

              {tipoArticulo === "servicio" && (
                <>
                  <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                    <DatosServicio articulo={articuloData} />
                  </Grid>
                </>
              )}

              {tipoArticulo === "solucion-limpieza" && (
                <>
                  <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                    <DatosSolucionLimpieza articulo={articuloData} />
                  </Grid>
                </>
              )}

              {tipoArticulo === "tratamiento" && (
                <>
                  <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                    <DatosTratamiento articulo={articuloData} />
                  </Grid>
                </>
              )}

              {obtenerStock && articuloStockAreaRows.length == 0 && (
                <Grid item xs={12} sx={{ m: 2 }}>
                  <Typography variant="h5" fontWeight="bold">
                    Artículo sin stock disponible
                  </Typography>
                </Grid>
              )}

              {articuloStockAreaRows.length > 0 && (
                <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                  <DataGrid
                    rows={articuloStockAreaRows}
                    columns={tableColumns}
                    {...tableOptions}
                  />
                </Grid>
              )}
            </Grid>
          </Box>
        </Paper>
      </Paper>

      {/* >>>> Messages */}

      {showMessage && (
        <Message showMessage={showMessage} setShowMessage={setShowMessage} message={message} />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default ConsultaArticulo;
